import React from "react";
import { Link } from "react-router-dom";
import { Constants } from "../../CommonMethhods/Constants";

function NewQuickLinks() {
  return (
    <>
      <div className="card-box newquick-link">
        <div className="card-title">
          <h2>{Constants.Quick_Links}</h2>
          {/* <div>
                    <span className="icon-arrow-right"></span>
                    <span className="icon-arrow-left"></span>
                </div> */}
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-4 col-12 bottom-mobile-screen">
            <Link
              className="newquick-link-box"
              to="/onboarding"
              target="_blank"
            >
              <span className="icon-client-list quick-icon "></span>
              <p className="quick-link-label">{Constants.Client_List}</p>
            </Link>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4 col-12 bottom-mobile-screen">
            <span
              className="newquick-link-box"
              // to="/knowledge-center"
              // target="_blank"
            >
              <span className="icon-knowledge-center quick-icon"></span>
              <p className="quick-link-label">{Constants.Knowledge_Centre}</p>
              <h6 className="coming-soon-msg">Coming Soon</h6>
            </span>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4 col-12">
            <Link
              className="newquick-link-box"
              to="/client-support"
              target="_blank"
            >
              <span className="icon-help-guide quick-icon"></span>
              <p className="quick-link-label">{Constants.Help_Guide}</p>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewQuickLinks;
